import {
  Alert,
  Box,
  Button,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import { Typography } from '@components/styledComponents';

export default function DataTable({
  title = '',
  columns = [],
  isLoading,
  data,
  errorMessage = 'errr',
  setDrawerJson,
  setDrawerTitle,
  setIsDrawerOpen,
  exploreOrder,
}) {
  if (data === null && !isLoading && !errorMessage) return null;

  const isSingleData = !Array.isArray(data);
  const displayData = isSingleData ? [data] : data;

  return (
    <>
      <Typography
        variant="formHeader"
        style={{ marginTop: '50px', marginBottom: '5px  ' }}>
        {title} {isLoading && <LinearProgress />}
      </Typography>

      {errorMessage && (
        <Box>
          <Alert
            onClose={() => {}}
            severity="error">
            {errorMessage}
          </Alert>
        </Box>
      )}

      {!errorMessage && (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={column.field}
                    align={column.align || 'left'}
                    style={{
                      paddingLeft: index === 0 ? 0 : '16px',
                      display:
                        column.hideIf && column.hideIf({ row: displayData[0] })
                          ? 'none'
                          : 'table-cell',
                      ...column.style,
                    }}>
                    {column.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {displayData.map((row) => (
                <TableRow
                  hover
                  key={row?.headerName}>
                  {columns.map((column, index) => {
                    if (row === null) return null;

                    let value = '';

                    if (column.valueGetter) {
                      value = column.valueGetter({ row });
                    } else if (!Array.isArray(row)) {
                      value = row[column.field];
                    }

                    if (value === null) {
                      value = 'null';
                    }

                    if (typeof value === 'boolean') {
                      value = value.toString();
                    }

                    return column.showJSON ? (
                      <TableCell
                        align="center"
                        key={column.field}>
                        <Button
                          variant="text"
                          size="small"
                          onClick={() => {
                            setDrawerTitle(title);
                            setDrawerJson(value);
                            setIsDrawerOpen(true);
                          }}>
                          Expand
                        </Button>
                      </TableCell>
                    ) : (
                      <TableCell
                        component="th"
                        scope="row"
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${column.field}-${index}`}
                        align={column.align || 'left'}
                        style={{
                          paddingLeft: index === 0 ? 0 : '16px',
                          display:
                            column.hideIf &&
                            column.hideIf({ row: displayData[0] })
                              ? 'none'
                              : 'table-cell',
                          ...column.style,
                        }}>
                        {value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {isSingleData && exploreOrder && data?.orderId && (
        <Box style={{ marginTop: '20px' }}>
          <Button
            variant="outlined"
            size="large"
            onClick={() => exploreOrder(data?.orderId)}>
            Explore Order {data.orderId}
          </Button>
        </Box>
      )}
    </>
  );
}
